import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { SimpleTreeView } from '@mui/x-tree-view/SimpleTreeView';
import { TreeItem } from '@mui/x-tree-view/TreeItem';
import images from '../../../../../assets/images';
import { useTranslation } from 'react-i18next';
export const SectionsSummary = ({ data, onSectionClick }) => {
    const { t } = useTranslation();
    const ExpandIcon = () => _jsx("img", { src: images.arrowBottom, alt: "Expand", style: { width: '16px', height: '16px' } });
    const CollapseIcon = () => _jsx("img", { src: images.arrowTop, alt: "Collapse", style: { width: '16px', height: '16px' } });
    const [selectedItems, setSelectedItems] = useState([]);
    const [expandedItems, setExpandedItems] = useState([]);
    useEffect(() => {
        if (data && (data === null || data === void 0 ? void 0 : data.length) > 0 && data[0].subContents.length > 0) {
            setSelectedItems([data[0].subContents[0].contentId]);
            setExpandedItems([data[0].contentId]);
        }
    }, [data]);
    const handleExpandedItemsChange = (event, itemIds) => {
        setExpandedItems(itemIds);
    };
    const handleSelectedItemsChange = (event, itemIds) => {
        setSelectedItems(itemIds);
    };
    return (_jsx("div", Object.assign({ className: "Section-summary-form" }, { children: _jsx(SimpleTreeView, Object.assign({ selectedItems: selectedItems, expandedItems: expandedItems, onExpandedItemsChange: handleExpandedItemsChange, onSelectedItemsChange: handleSelectedItemsChange }, { children: data === null || data === void 0 ? void 0 : data.map((section) => section.subContents.length === 1 ? (_jsx(TreeItem, { itemId: `${section.contentId}`, label: t(section.subContents[0].contentText), onClick: (e) => {
                    e.stopPropagation();
                    onSectionClick(section.subContents[0].contentId);
                } }, `${section.contentId}`)) : (_jsx(TreeItem, Object.assign({ itemId: `${section.contentId}`, label: t(section.contentText), slots: {
                    expandIcon: ExpandIcon,
                    collapseIcon: CollapseIcon,
                } }, { children: section.subContents.map((subSection) => (_jsx(TreeItem, { itemId: `${subSection.contentId}`, label: t(subSection.contentText), onClick: (e) => {
                        e.stopPropagation();
                        onSectionClick(subSection.contentId);
                    } }, `${subSection.contentId}`))) }), `${section.contentId}`))) })) })));
};
